import React, { useState } from 'react';
import {
    Box,
    FlatList,
    HStack,
    VStack,
} from 'native-base';
import {
    LocationDetail,
    Retailer,
    MenuType,
    FulfillmentOptionsCardProp,
    OrderType,
    useTheme,
} from '@springbig/shared';
import { Caption, H1 } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import { storeSchedule } from './StoreModal';
import { Button, Input } from '~/shared/Theme';

export type StoreLocationsType = 'page' | 'modal';

type StoreLocationsProps = {
    stores: Array<{
        locationDetail: LocationDetail;
        retailer: Retailer;
    }>;
    setRetailer: (retailer: Retailer) => void;
    setMenuType: (menuType: MenuType) => void;
    setFullfillmentOption: (value: FulfillmentOptionsCardProp) => void;
    type: StoreLocationsType;
    internalRetailer?: Retailer;
    isMerchantGeoLocation?: boolean;
};

export const StoreLocations = ({
    stores,
    setRetailer,
    setMenuType,
    setFullfillmentOption,
    type = 'page',
    internalRetailer,
    isMerchantGeoLocation
}: StoreLocationsProps) => {

    const {
        button_primary,
        button_text,
        primary,
        highlight_text
    } = useTheme();

    const [filteredStore, setFilteredStores] = useState(stores);
    const [selectType, setSelectType] = useState(false);
    const [selectedRetailer, setSelectedRetailer] = useState<Retailer>();

    const setFullfillmentOptionMethod = (_selectedRetailer: Retailer) => {

        const availableFulfillmentOptions: Array<FulfillmentOptionsCardProp> = [];
        if (_selectedRetailer?.fulfillmentOptions.pickup) {
            availableFulfillmentOptions.push({ key: OrderType.Pickup, label: 'pickup', isOpen: storeSchedule(OrderType.Pickup, _selectedRetailer) });
        }

        if (_selectedRetailer?.fulfillmentOptions.curbsidePickup) {
            availableFulfillmentOptions.push({ key: OrderType.CurbsidePickup, label: 'curbside pickup', isOpen: storeSchedule(OrderType.CurbsidePickup, _selectedRetailer) });
        }

        if (_selectedRetailer?.fulfillmentOptions.driveThruPickup) {
            availableFulfillmentOptions.push({ key: OrderType.DriveThruPickup, label: 'drive thru pickup', isOpen: storeSchedule(OrderType.DriveThruPickup, _selectedRetailer) });
        }

        if (_selectedRetailer?.fulfillmentOptions.delivery) {
            availableFulfillmentOptions.push({ key: OrderType.Delivery, label: 'delivery', isOpen: storeSchedule(OrderType.Delivery, _selectedRetailer) });
        }

        if (availableFulfillmentOptions && availableFulfillmentOptions[0]) {
            setFullfillmentOption(availableFulfillmentOptions[0]);
        }
    };

    if (selectType) {
        return (
            <VStack p={4} space={4}>
                <Button
                    modifier={'unlocked'}
                    variant={'text'}
                    onPress={() => setSelectType(false)}
                >
                    <HStack alignItems={'center'} space={2}>
                        <SpIcon icon={faArrowLeft} color={button_primary} />
                        <Caption text={'general.back'} color={button_primary} />
                    </HStack>
                </Button>
                <FlatList
                    w={'100%'}
                    data={['Medical', 'Recreational']}
                    renderItem={({ item, index }) =>

                        <Button
                            key={index}
                            text={item}
                            mb={4}
                            alignItems={'center'}
                            onPress={() => {

                                if (selectedRetailer) {
                                    setRetailer(selectedRetailer);
                                    setMenuType(item.toString().toUpperCase() as MenuType);
                                    setFullfillmentOptionMethod(selectedRetailer);
                                }
                            }}
                        />
                    }
                />
            </VStack>
        );
    }

    return (
        <VStack
            alignItems={'center'}
            space={4}
        >
            { type === 'page' ?
                <H1 color={highlight_text} text={'shop.pick_your_location'} />
                :
                <></>
            }
            <Input
                w={'full'}
                placeholder="search stores"
                rightElement={
                    <Box px={2}>
                        <SpIcon size={20} icon={faSearch} color={primary} />
                    </Box>
                }
                onChangeText={(text: string) => {

                    if (text) {
                        const searchFilteredStores = filteredStore.filter(
                            (e) =>

                                e.retailer.name.toLocaleLowerCase().includes(text.toLocaleLowerCase())
                        );
                        setFilteredStores(searchFilteredStores);
                    }
                    else {
                        setFilteredStores(stores);
                    }
                }}
            />
            <FlatList
                data={filteredStore}
                w={'100%'}
                renderItem={({ item, index }) =>

                    <Button
                        modifier={'unlocked'}
                        variant={item.retailer.id === internalRetailer?.id ? 'button' : 'neutral'}
                        mb={filteredStore.length === index + 1 ? 0 : 4}
                        px={4}
                        minH={'40px'}
                        py={2}
                        key={index}
                        onPress={() => {

                            if (item.retailer.menuTypes.length >= 2) {
                                setSelectType(true);
                                setSelectedRetailer(item.retailer);
                            }
                            else {
                                setMenuType(item.retailer.menuTypes[0]);
                                setRetailer(item.retailer);
                                setFullfillmentOptionMethod(item.retailer);
                            }
                        }}
                    >
                        <HStack justifyContent={'space-between'} alignItems={'center'} space={2}>
                            <Caption
                                color={button_text}
                                numberOfLines={2}
                            >
                                { item.retailer.name }
                            </Caption>
                            {!isMerchantGeoLocation &&
                                <Caption color={item.retailer.id === internalRetailer?.id ? primary : button_text} textAlign={'right'} minW={'72px'}>
                                    { item?.locationDetail?.distance?.toFixed(1) } { item?.locationDetail?.unit === 'MI' ? 'miles' : 'km' }
                                </Caption>
                            }
                        </HStack>
                    </Button>
                }
            />
            { filteredStore.length === 0 &&
                <Caption
                    text={'shop.no_matching_location'}
                />
            }
        </VStack>
    );
};
